// Localização: frontend/src/utils/stripeConfig.js
// Configuração do Stripe para o frontend

import { loadStripe } from '@stripe/stripe-js';

/**
 * Determina qual chave pública usar baseado no ambiente
 */
const getStripePublicKey = () => {
    // Em desenvolvimento, priorizar chave de teste
    // Em produção, usar chave de produção
    const isDevelopment = process.env.NODE_ENV === 'development' || 
                         !process.env.NODE_ENV || 
                         process.env.NODE_ENV === '';
    
    // Tentar obter a chave apropriada
    let publicKey = null;
    
    if (isDevelopment) {
        // Em desenvolvimento: priorizar chave de teste, depois produção
        publicKey = process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY || process.env.REACT_APP_STRIPE_PUBLIC_KEY;
    } else {
        // Em produção: priorizar chave de produção, depois teste (fallback)
        publicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY || process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY;
    }
    
    if (!publicKey) {
        return null;
    }
    
    // Validar formato da chave
    if (!publicKey.startsWith('pk_test_') && !publicKey.startsWith('pk_live_')) {
        console.warn(
            '⚠️ [StripeConfig] Chave pública do Stripe com formato inválido. ' +
            'Deve começar com pk_test_ (teste) ou pk_live_ (produção). ' +
            'Chave recebida começa com:', publicKey.substring(0, 10)
        );
    }
    
    return publicKey;
};

/**
 * Carrega e retorna instância do Stripe (promise)
 * Esta é a forma recomendada pelo Stripe para carregar o Stripe.js
 */
const stripePromise = (() => {
    const publicKey = getStripePublicKey();
    
    if (!publicKey) {
        // Retornar promise rejeitada se não houver chave
        return Promise.reject(new Error('Chave pública do Stripe não configurada. Verifique as variáveis REACT_APP_STRIPE_PUBLIC_KEY ou REACT_APP_STRIPE_TEST_PUBLIC_KEY no .env'));
    }
    
    // Carregar Stripe e tratar erros
    return loadStripe(publicKey).catch((error) => {
        throw error;
    });
})();

/**
 * Verifica se está usando chave de teste
 */
const isUsingTestKey = () => {
    const publicKey = getStripePublicKey();
    return publicKey && publicKey.startsWith('pk_test_');
};

/**
 * Retorna informações do ambiente Stripe
 */
const getStripeInfo = () => {
    const publicKey = getStripePublicKey();
    const isTest = isUsingTestKey();
    
    return {
        hasPublicKey: !!publicKey,
        isTest,
        environment: isTest ? 'test' : 'production',
        keyPrefix: publicKey ? publicKey.substring(0, 8) + '...' : 'não configurado',
    };
};

// Exportar promise do Stripe (padrão)
export default stripePromise;

// Exportar funções auxiliares
export {
    getStripePublicKey,
    isUsingTestKey,
    getStripeInfo,
};

